import React from 'react';
import PropTypes from 'prop-types';
import { colorGray } from 'styles/layout/colors';

const IconClock = ({
  className = '',
  color = colorGray,
  height = 16,
  width = 16,
}) => (
  <svg
    className={className}
    fill="none"
    height={height}
    viewBox="0 0 24 24"
    width={width}
  >
    <path stroke={color} strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>

);

IconClock.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};

export default IconClock;
